import React from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import { Link, useNavigate } from "react-router-dom";
import CookieConsent, { Cookies, getCookieConsentValue , resetCookieConsentValue  } from "react-cookie-consent";
import { useCookies } from 'react-cookie';


function Forgotpassword(props) {
    return (
        <div className="w-login row w-fullscreen">
            <div className='col-lg-6 bg-blue w-half-left'>
                <img className="w-img-xl" src="/img/categories/login.png" alt="login" />
            </div>
            <form className='col-lg-6 w-half-right'>
                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="login" />

                <Text text="Mot de passe oublié" classes="w-text-blue-l" />
                <Input text=" " type="email" placeholder="Saisir votre E-mail" classes="w-input" />
                    <Button text="Valider !" classes="w-btn-blue-lg" />
                <Link to="/login">
                    <Text text="Se connecter maintenant" classes="w-text-black-m" />
                </Link>
                 
            </form>
            <CookieConsent
                location="bottom"
                buttonText="Bien sûr !"
                cookieName="w-coockies-acceptation"
                style={{ background: "#0179bf" }}
                buttonStyle={{ color: "#0179bf", fontSize: "13px",borderRadius: "50px",background: "#fff" }}
                expires={150}
            > 
                Notre site utilise les coockies pour vous donner une meilleur expérience lors de son utilisation... <b>Avouez que c'est bon les coockies 🍪🍪🍪!</b>
                 
            </CookieConsent>
        </div>
    );
}

export default Forgotpassword;